<template>
    <div class="">
        <h2>Market Aliases</h2>

        <b-alert variant="danger" show>
            <strong>Sku / Legacy ID</strong> reference the item to be <strong>replaced</strong>.
            <br/><br/>
            <strong>Override Sku / ID</strong> reference the <strong>replacement</strong> item.
            <br/><br/>
            The override will only apply in the selected <strong>state</strong>.
        </b-alert>


        <b-spinner size="large" v-if="physicalSkus.length == 0"></b-spinner>
        <b-table id="market_table" :items="records" :fields="tableFields" v-if="physicalSkus.length > 0" striped>
            <template #cell(override_sku)="row">
<!--                {{row.item}}-->
                {{getSkuForPhysicalProduct(row.item)}}
            </template>
            <template #cell(actions)="row">
                <b-button :disabled="preventInput" size="sm" @click="deleteRecord(row.item, row.index, $event.target)" class="mr-1" variant="danger">
                    <font-awesome-icon :icon="['fas','trash']"/>
                </b-button>
            </template>

            <template #bottom-row>
                <td>
                    <b-input type="text" placeholder="State" v-model="newRecord.state" v-if="rawInput" name="state"/>
                    <multiselect :options="states" name="state" v-model="stateSearch" label="fullState" track-by="state" placeholder="State" @input="$nextTick(() => getPublications())" selectLabel="" v-else></multiselect>
                </td>
                <!-- Publication Select -->
                <td>
                    <b-input type="text" placeholder="Sku" v-model="newRecord.sku" v-if="rawInput" name="sku" />
                    <span v-if="!rawInput">
                        <b-spinner v-show="fetchingPubs"></b-spinner>
                        <multiselect v-show="!fetchingPubs && publications.length > 0" name="sku" :disabled="publications.length === 0" :options="publications" v-model="skuSearch" label="sku" track-by="legacy_id" selectLabel=""></multiselect>
                    </span>
                </td>
                <td>
                    <b-input type="text" v-model="newRecord.legacy_id" placeholder="Legacy Id" v-if="rawInput" name="legacy_id" />
                    <span v-if="!rawInput" >
                        <p v-if="skuSearch" class="pt-2 pb-0">{{newRecord.legacy_id}}</p>
                        <p v-else class="text-black-50 pt-2 pb-0">Legacy id</p>
                    </span>
                </td>
                <td>
                    <span v-if="!rawInput">
                        <b-spinner v-if="fetchingPhysical"></b-spinner>
                        <multiselect v-show="!fetchingPhysical && physicalSkus.length > 0" name="physical_sku" :options="physicalSkus" v-model="overrideSkuSearch" value="ID" track-by="ID" label="sku" placeholder="Override" selectLabel=""></multiselect>
                    </span>
                </td>
                <td>
                    <b-input type="text" v-model="newRecord.override_id" placeholder="Override ID" name="physical_sku" v-if="rawInput"/>
                    <span v-if="!rawInput">
                        <p class="pt-2 pb-0">{{newRecord.override_id}}</p>
                    </span>
                </td>
                <!-- Physical Override Select -->
                <td>
                    <b-btn size="sm" variant="info" :disabled="preventInput" @click="addRecord">
                        <b-spinner size="sm" v-if="preventInput"></b-spinner>
                        <font-awesome-icon v-else :icon="['fas', 'plus']"/>
                    </b-btn>
                </td>
            </template>
        </b-table>
        <b-checkbox style="margin-bottom: 500px" v-model="rawInput" @input="$forceUpdate">Raw Input</b-checkbox>

    </div>
</template>

<script>
import states from "@/common/states";
export default {
    name: "PriceOverride",
    data: () => ({
        rawInput: false,
        newRecord: {
            state: null, sku: null, legacy_id: null, override_id: null,
        },
        stateSearch: null,
        skuSearch:null,
        overrideSkuSearch: null,
        records: [],
        tableFields: [{key:'state', sortable: true}, {key:'sku', sortable:true}, {key:'legacy_id', sortable:true}, {key:'override_sku', sortable: true}, {key:'override_id', sortable:true}, 'actions'],
        preventInput: false,
        fetchingPubs: false,
        fetchingPhysical: false,
        physicalSkus: [],
        publications: [],
        states: states,
    }),
    watch: {
        stateSearch(val) {
            if (!val)
                return;

            this.newRecord.state = val.state;
        },
        skuSearch(val) {
            this.newRecord.sku = val.sku;
            this.newRecord.legacy_id = val.legacy_id;
        },
        overrideSkuSearch(val) {
            this.newRecord.override_id = val.ID;
        }

    },
    methods: {
        getPhysicalSkus() {
            this.fetchingPhysical = true;
            this.physicalSkus = [];
            this.axios.get('/product/physical')
            .then((response) => {
                this.physicalSkus = response.data.products;
                this.fetchingPhysical = false;
            });
        },
        getPublications() {
            this.fetchingPubs = true;
            this.publications = [];
            this.axios.get('/product/publications', {params: {state: this.newRecord.state}})
            .then((response) => {
                this.fetchingPubs = false;
                this.publications = response.data;
            });
        },
        getRecords() {
            this.preventInput = true;
            this.axios.get('/dashboard/markets/all')
            .then(response => {
                this.records = response.data;
            }).finally(() => {
                this.preventInput = false;
            })
        },
        deleteRecord(item, index, ev) {
            this.preventInput = true;
            this.axios.post('/dashboard/markets/delete', {id: item.id})
            .then((response) => {
                this.$bvToast.toast("item removed.");
                this.getRecords();
            })
            .catch(() => {
                this.preventInput = false;
            })
        },
        addRecord() {
            if (!this.newRecord.state || !this.newRecord.legacy_id || !this.newRecord.override_id) {
                this.$bvToast.toast("State, Legacy ID, and Override ID are all required.", {
                    variant: 'danger'
                })
                return;
            }
            this.preventInput = true;
            this.axios.post('/dashboard/markets/', {state: this.newRecord.state, legacy_id: this.newRecord.legacy_id.toString(), sku: this.newRecord.sku, override_id: this.newRecord.override_id})
                .then(response => {
                    this.$bvToast.toast("saved successfully");
                    this.getRecords();
                    this.clearNew();
                })
                .catch((err) => {
                    this.$bvToast.toast(`Err: ${err}`, {variant: 'danger'});
                    this.preventInput = false;
                })
        },
        clearNew() {
            this.newRecord = {state: this.newRecord.state, sku: null, legacy_id: null, override_id: null};
        },
        getSkuForPhysicalProduct(item) {
            let overrideLegacyId = item.override_id;
            for (let i = 0; i < this.physicalSkus.length; ++i) {
                if (this.physicalSkus[i].ID == overrideLegacyId)
                    return this.physicalSkus[i].sku;
            }
            return "NA";
        },
    },
    created() {
        this.getPhysicalSkus();
        this.getRecords();
    }
}
</script>

<style scoped>
#market_table {
}
</style>